import { call, put } from 'redux-saga/effects';
import dayjs from 'dayjs';
import ObrasApi from 'Data/Obras.api';
import toastHandler from 'Utils/toastHandler';
import { Mixpanel } from 'Utils/MixPanel';
import { ListagemArquivosActions, DownloadFilesAction } from './ListagemArquivos.actions';

export function* downloadFiles({ payload }: DownloadFilesAction) {
  const { userInfoTracking, currentTenantTracking, tenantIds } = payload;
  delete payload.userInfoTracking;
  delete payload.currentTenantTracking;
  delete payload.tenantIds;

  try {
    const beforeDownload = dayjs();
    const { data } = yield call(ObrasApi.downloadFiles, payload);

    const downloadResponseTime = dayjs().diff(beforeDownload, 'milliseconds');
    Mixpanel.track({
      name: 'DOWNLOAD_FILE',
      props: {
        api: payload.api,
        constructionSiteId: payload.constructionSiteId,
        elapsed: downloadResponseTime,
      },
      userInfo: userInfoTracking,
      currentListTenant: currentTenantTracking,
      tenantIds,
    });

    yield put(ListagemArquivosActions.downloadFilesSuccess(data.data));
  } catch (e: any) {
    Mixpanel.track({
      name: 'DOWNLOAD_FILE_ERROR',
      props: {
        api: payload.api,
        constructionSiteId: payload.constructionSiteId,
      },
      userInfo: userInfoTracking,
      currentListTenant: currentTenantTracking,
      tenantIds,
    });

    const msg = 'Erro ao realizar download dos arquivos';
    const error = e.errors ? e.errors[0]?.Message || msg : msg;
    yield put(ListagemArquivosActions.downloadFilesFailure(error));
    toastHandler.showError(error);
  }
}
